var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowBoldRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 8h23M24 8l-6.606 6.606M24 8l-6.606-6.606",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export { SvgArrowBoldRight as ReactComponent };
export default __webpack_public_path__ + "/assets/e0b3128054908a0314c0c594912a5238.svg";